module.exports = __webpack_public_path__ + "img/mobcursor.8ea03cc4.svg";